import { Spid } from "@/icons/Spid";
import "./EntryButton.scss";
import { Row } from "@/components";

type EntryButtonProps = {
  href: string;
  asLink?: "a" | React.ComponentType<any>;
  showIcon?: boolean;
  icon?: React.ReactNode;
  ariaLabel: string;
  children: React.ReactNode;
};

export const EntryButton = ({
  href,
  asLink = "a",
  showIcon = false,
  icon,
  ariaLabel = "Accedi con SPID",
  children,
}: EntryButtonProps) => {
  const LinkComponent = asLink;
  return (
    <LinkComponent
      className="bg-primary min-h-x40 h-full base-row align-items-center br-x4 min-w-x252 text-decoration-none ui-entry-btn"
      href={href}
      rel={"noreferrer noopener"}
    >
      <Row py={"x8"} px={"x12"} className="items-center ui-entry-btn-spid">
        {icon ? (
          icon
        ) : showIcon ? (
          <Spid color="white" />
        ) : (
          <div style={{ width: 24, height: 24 }} aria-hidden="true" />
        )}
      </Row>
      <span
        className="p-x8 fw-bold text-white text-decoration-none fs-6"
        rel={"noreferrer noopener"}
      >
        {children}
        {ariaLabel && <span className="visually-hidden">{ariaLabel}</span>}
      </span>
    </LinkComponent>
  );
};
